import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { LogIn, LogOut, User } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import SignInModal from './SignInModal';

const AuthButton = () => {
  const { user, signOut } = useAuth();
  const [showSignInModal, setShowSignInModal] = useState(false);

  // Listen for openSignInModal event from other components
  useEffect(() => {
    const handleOpenSignIn = () => setShowSignInModal(true);
    window.addEventListener('openSignInModal', handleOpenSignIn);
    return () => window.removeEventListener('openSignInModal', handleOpenSignIn);
  }, []);

  if (!user) {
    return (
      <>
        <button
          onClick={() => setShowSignInModal(true)}
          className="w-full flex flex-col items-center gap-1 px-3 py-3 text-amber-600 hover:bg-amber-50 rounded-lg transition-all"
          data-auth-button
        >
          <LogIn className="w-5 h-5 flex-shrink-0" />
          <span className="text-[9px] font-medium leading-tight">Sign In</span>
        </button>
        <SignInModal 
          open={showSignInModal} 
          onOpenChange={setShowSignInModal}
          redirectPath="/profile"
        />
      </>
    );
  }

  // When logged in, return null (don't show anything in header)
  return null;
};

export default AuthButton;
